import { render } from "./HistoryOrder.vue?vue&type=template&id=08d5f22e&scoped=true"
import script from "./HistoryOrder.vue?vue&type=script&lang=js"
export * from "./HistoryOrder.vue?vue&type=script&lang=js"

import "./HistoryOrder.vue?vue&type=style&index=0&id=08d5f22e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-08d5f22e"

export default script